export const FETCH_CITY_AREA = "FETCH_CITY_AREA"
export const CREATE_CITY_AREA = "CREATE_CITY_AREA"
export const UPDATE_CITY_AREA = "UPDATE_CITY_AREA"
export const DELETE_CITY_AREA = "DELETE_CITY_AREA"
